/**
 * Public runtime surface for the clarification-loop contract family.
 *
 * Threat-model invariant: declared wire inputs arrive as JSON.parse data from the model,
 * REST/SSE, or persisted state. Each public contract first crosses the internal
 * trusted-parse boundary, which copies only owned data descriptors into plain data.
 * The server clock is reduced to primitive time by that same boundary. Callers must not
 * pass live in-process objects; rejected parses never reach validators or projectors.
 */
export * from './clarification-egress';
export * from './clarification-fences';
export * from './clarification-validation';
